<script>
// import AppStyles from '../../style/styles'
// import axios from 'axios'

import { Scatter } from 'vue-chartjs'

export default {
    extends: Scatter,
    props: [
        'readingdata',
        'weektempdata',
        'measurementtype',
        'weekData',
        'pooltitle'
    ],
    data () {
        return {
            gradient: '',
            scales: {
                'Free cl': {
                    min: 0,
                    max: 10,
                    stepSize: 1,
                    callback: (value, index) => index === 0 ? '> 10' : value
                },
                'pH': {
                    min: 6.5,
                    max: 8.5,
                    stepSize: 0.5,
                    callback: (value, index, values) => index === 0 ? '> 8.5' : index === values.length - 1 ? '< 6.5' : value
                },
                'Water Temp': {
                    callback: (value) => `${value}°F`
                }
            }
        }
    },

    watch: {
        measurementtype () {
            if (Object.keys(this.measurementtype).length) {
                this.DrawChart()
            }
        },
        pooltitle () {
            if (this.pooltitle && Object.keys(this.pooltitle).length) {
                this.DrawChart()
            }
        },
        readingdata () {
            if (Object.keys(this.readingdata).length > 0) {
                this.DrawChart()
            }
        }
    },

    mounted () {
        if (this.readingdata.length !== 0) this.DrawChart()
    },
    methods: {
        DrawChart () {
            let ctx = this.$refs.canvas.getContext('2d')
            this.gradient = ctx.createLinearGradient(0, 0, 0, 150)
            this.gradient.addColorStop(0, 'rgba(196,217,239,1)')
            this.gradient.addColorStop(1, 'rgba(196,217,239,0)')

            this.renderChart(
                {
                    datasets: [
                        {
                            label: this.measurementtype,
                            backgroundColor: '#fff',
                            borderColor: '#23b8dc',
                            showLine: true,
                            data: this.readingdata[this.measurementtype].sort((a, b) => a.x !== b.x ? 0 : (a.y - b.y))
                        }
                    ]
                },
                {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: { display: false },
                    elements: {
                        point: {
                            pointStyle: 'circle',
                            radius: 1,
                            hoverRadius: 1,
                            borderWidth: 6
                        },
                        line: { tension: 0.1 }
                    },
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            label: (tooltipItems, data) => (data.datasets[0].label + ': ') + (data.datasets[0].label === 'Water Temp' ? tooltipItems.yLabel + '°F' : tooltipItems.yLabel)
                        }
                    },
                    scales: {
                        xAxes: [
                            {
                                gridLines: { display: false, color: 'black' },
                                ticks: {
                                    callback: (value, index) => this.weekData[index]
                                }
                            }
                        ],
                        yAxes: [
                            {
                                stacked: true,
                                gridLines: { display: false, color: 'black' },
                                ticks: { ...this.scales[this.measurementtype], maxTicksLimit: 10 }
                            }
                        ]
                    }
                }
            )
        }
    }
}
</script>
